module.exports = __webpack_public_path__ + "static/header_usluge-547ccf713808de3cf38745da228719ec.jpg";